<!--
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-17 16:45:23
 * @LastEditTime: 2020-10-13 11:51:25
 * @Description: File description
-->
<template>
  <div className='canvas-content'>
    <canvas className='saveposter-poster' :id='`myCanvas${id}`' :width="pxWidth" :height="pxHeight"></canvas>
    <img className='saveposter-posterimg' :src="canvasposterImgUrl"/>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    diy: {
      type: Boolean,
      default: false
    },
    bgImg: {
      type: String,
      default: ''
    },
    qrCode: {
      type: String,
      default: ''
    },
    posterId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      canvas: '',
      pxWidth: 750,
      canvasCtx: '',
      pxHeight: 1200,
      canvasposterImgUrl: ''
    }
  },
  watch: {
    bgImg () {
      const { canvasCtx, canvas } = this
      canvasCtx.clearRect(0, 0, canvas.width, canvas.height)
      this.drawCanvas()
    },
    qrCode (val) {
      console.log(val)
    }
  },
  mounted () {
    this.drawCanvas()
  },
  methods: {
    async drawCanvas () {
      const poster = {
        x: 0,
        y: 0,
        width: 750,
        height: 1200,
        url: this.bgImg
      }
      const qrcode = {
        x: 578,
        y: 1020,
        width: 122,
        height: 122,
        url: this.qrCode
      }
      const canvas = document.querySelector(`#myCanvas${this.id}`)
      this.canvas = canvas
      this.canvasCtx = canvas.getContext('2d')
      await this.drawImage(poster)
      if (this.diy) {
        this.canvasCtx.beginPath()
        this.canvasCtx.arc(638, 1081, 61, 0, 2 * Math.PI)
        this.canvasCtx.fillStyle = '#ffffff'
        this.canvasCtx.fill()
      }
      await this.drawImage(qrcode)
      this.canvasposterImgUrl = canvas.toDataURL('image/png')
      this.$emit('posterDrawed', this.posterId, this.canvasposterImgUrl)
      this.$xesLogger.clickMsg({ params: { action: 'canvasImg', clickid: '5.3.16', posterId: `${this.id + 1}` } })
    },
    drawImage (params) {
      console.log(params)
      return new Promise(resolve => {
        const { canvasCtx } = this
        const { x, y, width, height, url } = params
        canvasCtx.save()
        // 创建一个Image对象，实现图片的预下载
        const img = new Image()
        img.setAttribute('crossorigin', 'anonymous')
        img.src = url || this.qrCode
        // 图片下载完成后续处理
        const imgDraw = () => {
          // 设置了图片的宽度和高度
          if (width) {
            canvasCtx.drawImage(img, x, y, width, height)
          } else {
            // 图片比画布宽，等比缩放
            if (img.width > this.pxWidth) {
              const scaleWidth = this.pxWidth
              const scaleHeight = (scaleWidth * img.height) / img.width
              canvasCtx.drawImage(img, x, y, scaleWidth, scaleHeight)
            } else {
              canvasCtx.drawImage(img, x, y)
            }
          }
          canvasCtx.restore()
          resolve()
        }
        img.onload = imgDraw
      })
    }
  }
}
</script>
